import React from 'react';
import { Card, Box, Typography } from '@mui/material';
import { COLOR, FUENTE } from '../../Recepcion/reportes/tokens';

/**
 * Por qué rechaza ANSES.
 *
 * Es lo más accionable del reporte: dice qué corregir antes de volver. Va como lista y no como
 * gráfico porque lo que importa es leer el texto del motivo, no comparar magnitudes.
 *
 * Los motivos se escriben a mano y el backend los agrupa normalizados ("Falta DNI" y
 * "falta d.n.i." son el mismo), mostrando la primera forma en que se escribió.
 *
 * @param {{data: Array<{motivo: string, cantidad: number}>}} props
 */
const MotivosRechazoLista = ({ data }) => {
    const filas = data || [];
    const total = filas.reduce((acc, f) => acc + f.cantidad, 0);
    const maximo = filas.reduce((acc, f) => Math.max(acc, f.cantidad), 0);

    return (
        <Card variant="outlined" sx={{ border: '1px solid #e2e8f0', borderRadius: '12px', boxShadow: 'none', padding: '18px 20px' }}>
            <Typography sx={{ fontFamily: FUENTE, fontSize: 15, fontWeight: 700, color: COLOR.negro, marginBottom: '2px' }}>
                Por qué rechaza ANSES
            </Typography>
            <Typography sx={{ fontFamily: FUENTE, fontSize: 12.5, color: COLOR.grisTexto, marginBottom: '14px' }}>
                {total > 0
                    ? `${total} rechazo${total === 1 ? '' : 's'} con motivo registrado. Es lo que hay que corregir antes de volver.`
                    : 'Todavía no hay rechazos con motivo registrado.'}
            </Typography>

            {filas.length === 0 ? (
                <Typography sx={{ fontFamily: FUENTE, fontSize: 13, color: COLOR.grisFrio, padding: '24px 0', textAlign: 'center' }}>
                    Sin rechazos en el período.
                </Typography>
            ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {filas.map((f) => (
                        <Box key={f.motivo}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '12px', marginBottom: '4px' }}>
                                <Typography sx={{ fontFamily: FUENTE, fontSize: 13, color: COLOR.negro }}>
                                    {f.motivo}
                                </Typography>
                                <Typography sx={{ fontFamily: FUENTE, fontSize: 13, fontWeight: 700, color: COLOR.rojo, fontVariantNumeric: 'tabular-nums' }}>
                                    {f.cantidad}
                                </Typography>
                            </Box>
                            {/* La barra es proporcional al motivo más frecuente, para ver de un
                                vistazo si hay uno que domina o están todos parejos. */}
                            <Box sx={{ height: 6, background: COLOR.gris, borderRadius: 3, overflow: 'hidden' }}>
                                <Box sx={{ height: '100%', width: `${maximo ? (f.cantidad / maximo) * 100 : 0}%`, background: COLOR.rojoClaro, borderRadius: 3 }} />
                            </Box>
                        </Box>
                    ))}
                </Box>
            )}
        </Card>
    );
};

export default MotivosRechazoLista;
